module.exports = __webpack_public_path__ + "img/vistas.9159dd99.svg";